import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function TimeCircleIcon(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.75 4C8.19328 4 4.5 7.69328 4.5 12.25C4.5 16.8067 8.19328 20.5 12.75 20.5C17.3067 20.5 21 16.8067 21 12.25C21 7.69328 17.3067 4 12.75 4ZM2.5 12.25C2.5 6.58872 7.08872 2 12.75 2C18.4113 2 23 6.58872 23 12.25C23 17.9113 18.4113 22.5 12.75 22.5C7.08872 22.5 2.5 17.9113 2.5 12.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4121 7.09668C12.9644 7.09668 13.4121 7.54439 13.4121 8.09668V12.3758L16.6944 14.3339C17.1687 14.6168 17.3239 15.2307 17.0409 15.705C16.758 16.1793 16.1441 16.3344 15.6698 16.0515L11.8998 13.8025C11.5974 13.6221 11.4121 13.2958 11.4121 12.9437V8.09668C11.4121 7.54439 11.8598 7.09668 12.4121 7.09668Z"
        fill="currentColor"
      />
    </IconWrapper>
  );
}
